// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rw-2";
export var chatLink = "_rw-0";
export var chatText = "_rw-1";